import { useModal } from '@ebay/nice-modal-react';
import { Divider, List, Checkbox, SubTitle, Icon } from '@repo/ui';
import { TermDrawer } from '@repo/user-sign';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

export const TermsForm = () => {
  const { control } = useFormContext();
  const modal = useModal(TermDrawer);

  const termNames: Record<
    string,
    {
      label: string;
      description?: string;
    }
  > = {
    'bznav-taxrefund-delegation': {
      label: '[필수] 경정청구업무 위임동의서',
      description: '경정청구를 위한 일회성 세무대리 위임이 목적이며, 세무대리인 변경과는 무관합니다.'
    },
    'bznav-taxrefund-delegation-contract': {
      label: '[필수] 경정청구업무 권한 위임장',
      description: '경정청구 대리와 처리 결과 확인・수령 권한을 위임해요.'
    },
    'bznav-taxrefund-unique-identification': {
      label: '[필수] 고유식별정보 수집·이용동의'
    },
    'bznav-taxrefund-private-3rdagree': {
      label: '[필수] 개인 및 법인(신용)정보 수집·이용 및 제3자 제공 동의'
    }
  };

  const handleOpenTerm = (key: string) => {
    modal.show({
      link: `https://bznav.com/popup/terms/${key}`,
      keepMounted: true
    });
  };

  return (
    <>
      <SubTitle title={<span className={'font-bold'}>약관 및 안내 동의</span>} size={'large'} className={'!pb-normal-small mb-tiny-medium'} />
      <div className={'pb-normal-xlarge'}>
        <div className="container-padding-medium w-full rounded-bzc-medium border border-neutral-border-high">
          <Controller
            name="isAgreeTerm"
            control={control}
            render={({ field }) => (
              <List
                size={'medium'}
                className={'mt-tiny-large'}
                title={'전체 동의'}
                primaryAction
                onClick={() => field.onChange(!field.value)}
                leadingElement={<Checkbox isBox={true} checked={field.value} />}
              />
            )}
          />

          <Divider className={'mt-tiny-medium mb-tiny-large'} />
          <div className={'pb-normal-medium'}>
            {Object.entries(termNames).map(([key, value]) => {
              return (
                <List
                  key={key}
                  size={'small'}
                  title={<span className={'body-small-regular'}>{value.label}</span>}
                  description={value.description}
                  onClick={() => handleOpenTerm(key)}
                  supportingElement={<Icon type={'chevron-right'} size={16} color={'#8A96A3'} />}
                  primaryAction
                />
              );
            })}

            <List
              size={'small'}
              title={<span className={'body-small-regular'}>신고대리 이용료 후불 안내</span>}
              description={'환급 신청은 무료예요. 국세청 환급 결정이 된 후, 세무사 수수료로 환급금의 30%가 발생해요. (부가세별도)'}
            />
          </div>
        </div>
      </div>
    </>
  );
};
